import ErrorPage from '@/view/404'
import RouteIndex from './src/route-index'
import RouteAuth from './src/route-auth'
import qwAuthChildren from './src/route-qwAuth' //企业微信模块

import performance from './src/route-performance' //企业微信模块
import customerConversion from './src/route-customerConversion' //客户转化模块

import customer from './src/route-customerConversion'

//路由白名单
const whiteRouteUrl = [
  '/auth/login',
  '/auth/phoneLogin',
  '/qwAuth/login',
  '/qwAuth/register',
  '/qwAuth/bindPhone',
  '/qwAuth/bindCS',
  '/qwAuth/createdApp',
  '/qwAuth/configApp',
  '/qwAuth/createdContacts'
]
//静态路由
let defaultRouter = [
  RouteIndex,
  RouteAuth,
  qwAuthChildren,
  {
    path: '/404',
    component: ErrorPage
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('@/view/demo/index.vue')
  },
  {
    path: '/demo2',
    name: 'demo2',
    component: () => import('@/view/demo/index2.vue')
  },
  {
    path: '/customerConversion/commissionSettings',
    name: 'commissionSettings',
    component: () => import('@/view/commissionSettings/index.vue')
  }
]
//开发路由
let devRouter = [performance, customerConversion]

export default {
  whiteRouteUrl: whiteRouteUrl, //域名白名单
  defaultRouter: defaultRouter.concat(devRouter) //工程默认路由
}
